import { render, staticRenderFns } from "./tableActions.vue?vue&type=template&id=3605f5ba&scoped=true&lang=pug&"
import script from "./tableActions.vue?vue&type=script&setup=true&lang=js&"
export * from "./tableActions.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./tableActions.vue?vue&type=style&index=0&id=3605f5ba&prod&lang=scss&scoped=true&"
import style1 from "./tableActions.vue?vue&type=style&index=1&id=3605f5ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3605f5ba",
  null
  
)

export default component.exports